export const enum LoginStatusElectron {
  Away = 'not accepting chats',
  Online = 'accepting chats',
  Offline = 'offline',
}
